import {
  BiCalendarHeart,
  BsPersonFill,
  CloseLargeIcon,
  FaCalendarAlt,
  FaPhone,
  FaTransgender,
  IconFrame,
  ImLocation,
  MdEmail,
  VscSourceControl,
} from '@element/icons';
import { Backdrop, Box, ClickAwayListener } from "@material-ui/core";
import {
  getUserByTenantAndMobile,
  getUserSources,
  getUsersSalutation,
  sendOTP,
  updateUser,
  verifyAndRegister,
} from "@storeData/user";
import { isSharedLinkPath } from "@util/sharedLinkRoutes";
import { getDateObj, getGenericImages } from "@util/utils";
import { showError, showSuccess, showWarning } from "app/redux/actions/alert";
import {
  disableLoader,
  enableLoader,
  updateGenericImages,
} from "app/redux/actions/common";
import { updateUserData } from "app/redux/actions/user";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import DatePicker from "react-datepicker";
import PhoneInput from "react-phone-input-2";
import { useDispatch, useSelector } from "react-redux";

function UserRegistrationModal({
  fromPage = "",
  handleResponse,
  isApppGrpChangeOnUserGdrChange,
  open,
  heading,
  regMandatory = false,
}) {
  const dispatch = useDispatch();
  const [cookie, setCookie] = useCookies();
  const [error, setError] = useState({ id: "", text: "" });
  const baseRouteUrl = useSelector((state: any) => state.store.baseRouteUrl);
  const storeData = useSelector((state: any) =>
    state.store ? state.store.storeData : null,
  );
  const activeGroup = useSelector((state: any) => state.activeGroup);
  const [isMounted, setIsMounted] = useState(false);
  const [userFromCookies, setUserCookie] = useState(null);
  const [showRegistrationScreen, setShowRegistrationScreen] = useState(false);
  const [showWellcomeScreen, setShowWellcomeScreen] = useState(false);
  const { configData } = useSelector((state: any) =>
    state.store ? state.store.storeData : null,
  );
  const userConfig = configData?.storeConfig?.sparkConfig?.userConfig;
  const isUserRegMandatory =
    regMandatory || Boolean(userConfig?.userRegMandatory);
  const basicConfig = configData?.storeConfig?.basicConfig;
  const isGdprEnabled = basicConfig?.gdpr;
  const [showSignInPage, setShowSignInPage] = useState(
    fromPage != "PROFILE" ? true : false,
  );
  const [pageheight, setpageheight] = useState<any>("370px");
  const [showSigninInputs, setShowSigninInputs] = useState(
    fromPage == "INITIAL_LOAD" ? false : true,
  );
  const storeMetaData = useSelector((state: any) =>
    state.store ? state.store.storeMetaData : null,
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElSalutation, setAnchorElSalutation] = useState(null);
  const [sourcesList, setSourcesList] = useState([]);
  const [salutationTypeList, setSalutationTypeList] = useState([]);
  const [openOTPModal, setOpenOTPModal] = useState<boolean>(false);
  const [otp, setOtp] = useState<number>(null);
  const [otpMsg, setOtpMsg] = useState("");
  const [timer, setTimer] = useState(0);
  const otpRegistration = Boolean(
    configData?.storeConfig?.sparkConfig?.otpRegistration?.active,
  );
  const otpExpiryTime =
    configData?.storeConfig?.sparkConfig?.otpRegistration?.expiryTime || 180;
  const store = useSelector((state: any) => state);
  const languageData: any = store.languageKeywords;
  const uniqueRecordIdentifier = new Date().getTime();

  useEffect(() => {
    setIsMounted(true);
    setUserCookie(cookie["user"]);
  }, []);

  useEffect(() => {
    if (fromPage == "INITIAL_LOAD" && Boolean(userConfig?.hideRegPopupOnLoad)) {
      setShowRegistrationScreen(false);
      setShowWellcomeScreen(false);
      handleClose();
      return;
    }

    if (fromPage == "INITIAL_LOAD") setShowSigninInputs(false);
    setOpenOTPModal(false);
    setOtp(null);
  }, [open]);

  const DatePickerInput = forwardRef((props: any, ref: any) => (
    <button className="date-picker-button" onClick={props.onClick} ref={ref}>
      {props.value ? (
        <>
          {props.from == "Birth date"
            ? `${languageData["Birth date"] ? languageData["Birth date"] : "Birth date"}:`
            : `${languageData["Anniversary date"] ? languageData["Anniversary date"] : "Anniversary date"}:`}{" "}
          {props.value}
        </>
      ) : (
        <>
          {props.from == "Birth date"
            ? `${languageData["Birth date"] ? languageData["Birth date"] : "Birth date"}`
            : `${languageData["Anniversary date"] ? languageData["Anniversary date"] : "Anniversary date"}`}
        </>
      )}
    </button>
  ));

  const openDatePickerFromRow = (event: any) => {
    const button = event.currentTarget.querySelector(".date-picker-button");
    if (button && event.target !== button && !button.contains(event.target)) {
      button.click();
    }
  };

  const modalRef = useRef(null);
  const modalWrapRef = useRef(null);
  const loginNumberInput = useRef<HTMLInputElement>(null);
  const signUpFormRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const modalWrap: HTMLElement | null = modalWrapRef.current;
    if (!modalWrap) return;

    const syncHeight = () => {
      const contentHeight = modalWrap.scrollHeight + 10;
      setpageheight(`${contentHeight}px`);
    };
    syncHeight();

    // The form keeps growing after mount while profile data, salutations and
    // sources load. A one-off measurement left the sheet shorter than its content,
    // and because this flow does not clip, the footer ended up off screen.
    if (typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(syncHeight);
    observer.observe(modalWrap);
    return () => observer.disconnect();
  }, [showSignInPage, showSigninInputs, error, open, isMounted]);

  useEffect(() => {
    const ele: any = document.getElementById("sign-in-phone");
    if (showSigninInputs && ele && showSignInPage) {
      setTimeout(() => {
        ele.focus();
      }, 600);
    }
  }, [showSigninInputs, showSignInPage]);

  const [userData, setUserData] = useState({
    mobileNo: "",
    firstName: "",
    lastName: "",
    email: "",
    marketingConsent: !isGdprEnabled,
    consentSource: "CATALOGUE",
    area: "",
    gender: "",
    dob: "",
    source: "",
    countryCode: "",
    anniversaryDate: "",
    addressList: [],
    storeId: storeData?.storeId ? storeData?.storeId : "",
    tenantId: storeData?.tenantId ? storeData?.tenantId : "",
    salutation: "",
    isGlobal: Boolean(userConfig?.defaultGlobalUser),
  });

  useEffect(() => {
    if (error.id) {
      if (window?.navigator && window?.navigator?.vibrate) {
        window?.navigator?.vibrate([200, 100, 200]);
      }
      let element = document.getElementById(error.id);
      if (element) {
        element.classList.add("shaker");
        setTimeout(() => {
          element.classList.remove("shaker");
        }, 1000);
      }
    }
  }, [error]);

  useEffect(() => {
    if (userConfig?.showAddress) {
      setUserData({
        ...userData,
        addressList: [
          {
            area: "",
            city: "",
            code: "",
            landmark: "",
            latitude: null,
            line: "",
            longitude: null,
            type: "Home",
          },
        ],
      });
    }
    // Registration is unreachable on shared invoice/feedback links, where this modal is only
    // mounted for the single render before the mini header takes over. Fetching the source list
    // there spends the customer's rate-limit budget on a dropdown they will never see.
    const isSharedLink =
      typeof window !== "undefined" &&
      isSharedLinkPath(window.location.pathname);
    if (userConfig.showSource && !isSharedLink) {
      getUserSources(storeData?.tenantId, storeData?.storeId).then(
        (res: any) => {
          if (res.data) {
            setSourcesList(res.data.filter((d: any) => d.active));
          }
        },
      );
    }
  }, []);

  useEffect(() => {
    if (!isMounted) return;
    if (fromPage == "INITIAL_LOAD") {
      setCookie("baseRouteUrl", baseRouteUrl, {
        path: "/",
        expires: new Date(new Date(2147483647 * 1000).toUTCString()),
        sameSite: true,
      });
      const wellcomeScreenTime = cookie["wst"];
      const registrationScreenTime = cookie["rst"];
      if (!userFromCookies && !registrationScreenTime) {
        // console.log('time expiry registrationScreenTime');
        setShowWellcomeScreen(false);
        setShowRegistrationScreen(true);
        setCookie("rst", new Date(), {
          //registration-screen-time
          path: "/",
          expires: new Date(
            new Date().setMinutes(new Date().getMinutes() + 30),
          ),
          sameSite: true,
        });
      } else if (userFromCookies && !wellcomeScreenTime) {
        // console.log('time expiry wellcomeScreenTime');
        setShowRegistrationScreen(false);
        setShowWellcomeScreen(true);
        setCookie("wst", new Date(), {
          //wellcome-screen-time
          path: "/",
          expires: new Date(
            new Date().setMinutes(new Date().getMinutes() + 30),
          ),
          sameSite: true,
        });
      } else if (
        !userFromCookies &&
        !registrationScreenTime &&
        userConfig?.userRegPopupReq
      ) {
        setShowRegistrationScreen(true);
      } else {
        handleClose();
      }
    } else {
      setShowRegistrationScreen(true);
      setCookie("rst", new Date(), {
        //registration-screen-time
        path: "/",
        expires: new Date(new Date().setMinutes(new Date().getMinutes() + 30)),
        sameSite: true,
      });
    }
  }, [fromPage]);

  useEffect(() => {
    getSalutations().then((salutationsList: any) => {
      setSalutationTypeList(salutationsList);
      const user = cookie["user"];
      if (user && user?.mobileNo) {
        if (user.firstName.includes(" ")) {
          const salutation = user.firstName.split(" ")[0];
          const index = salutationsList.findIndex(
            (s: any) => s.name == salutation,
          );
          if (index != -1) {
            user.salutation = salutation;
            user.firstName = user.firstName.split(`${salutation} `)[1];
          }
        }
        setUserData(user);
      } else
        setUserData({
          mobileNo: "",
          firstName: "",
          lastName: "",
          email: "",
          marketingConsent: !isGdprEnabled,
          consentSource: "CATALOGUE",
          area: "",
          gender: "",
          countryCode: "",
          dob: "",
          source: "",
          anniversaryDate: "",
          addressList: [],
          storeId: storeData?.storeId ? storeData?.storeId : "",
          tenantId: storeData?.tenantId ? storeData?.tenantId : "",
          salutation: "",
          isGlobal: Boolean(userConfig?.defaultGlobalUser),
        });
    });
  }, [userFromCookies, open]);

  useEffect(() => {
    if (configData && configData.genericImages) {
      dispatch(updateGenericImages(getGenericImages(configData, activeGroup)));
    }
  }, [activeGroup, configData]);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const getSalutations = () => {
    return new Promise((res, rej) => {
      if (salutationTypeList.length == 0) {
        if (basicConfig.salutation) {
          try {
            getUsersSalutation(
              storeData?.tenantId,
              storeData?.storeId,
              "",
            ).then((response: any) => {
              if (response.data) {
                res(response.data.filter((d: any) => d.active));
              } else {
                res([]);
              }
            });
          } catch (error) {
            res([]);
          }
        } else {
          res([]);
        }
      } else {
        res(salutationTypeList);
      }
    });
  };

  const handleClose = (user = null) => {
    if (user && user.firstName) handleResponse(user);
    else handleResponse();
    setError({ id: "", text: "" });
    setShowSignInPage(true);
  };

  const wrongEmail = () => {
    if (
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        userData.email,
      )
    )
      return false;
    else return true;
  };

  const validateLoginForm = () => {
    if (!userData || !userData.mobileNo || !validateNumber(userData.mobileNo)) {
      setError({ id: "phone", text: "" });
      return false;
    } else if (!userData.firstName) {
      setError({ id: "firstName", text: "" });
      return false;
    } else if (
      !userData.email &&
      userConfig?.emailMandatory &&
      userConfig?.showEmail
    ) {
      setError({ id: "email", text: "" });
      return false;
    } else if (
      userConfig?.addressMandatory &&
      userConfig?.showAddress &&
      (userData.addressList.length == 0 || !userData.addressList[0].line)
    ) {
      setError({ id: "line", text: "" });
      return false;
    } else if (
      userConfig.showGender &&
      userConfig?.genderSelectionMandatory &&
      !userData.gender
    ) {
      setError({ id: "gender", text: "" });
      return false;
    } else {
      return true;
    }
  };

  const setAuthToken = (res: any) => {
    const userDataHeader =
      res.headers?.["userdata"] || res.headers?.["UserData"];
    if (userDataHeader) {
      localStorage.setItem("User_Data", userDataHeader);
    }
    const currentHostname =
      typeof window !== "undefined" ? window.location.hostname : "";
    const isCustomDomain = !currentHostname.endsWith("respark.in");
    if (isCustomDomain) {
      const authHeader =
        res.headers?.["authorization"] || res.headers?.["Authorization"];
      if (authHeader) {
        localStorage.setItem("Auth_Token_Value", authHeader);
      }
    }
  };

  const registerUser = (userDetails) => {
    dispatch(enableLoader());
    updateUser(userDetails)
      .then((res: any) => {
        dispatch(disableLoader());
        if ("id" in userDetails) {
          dispatch(
            showSuccess(
              `${languageData["User updated successfully"] ? languageData["User updated successfully"] : "User updated successfully"}`,
            ),
          );
        } else {
          dispatch(
            showSuccess(
              `${languageData["User registered successfully"] ? languageData["User registered successfully"] : "User registered successfully"}`,
            ),
          );
        }
        userDetails = res.data;
        setAuthToken(res);
        // userDetails.firstName = userDetails.salutation ? `${userDetails.salutation} ${userDetails.firstName}` : userDetails.firstName;
        setCookie("user", userDetails, {
          //user registration fields
          path: "/",
          expires: new Date(
            new Date().setSeconds(new Date().getFullYear() + 1),
          ),
          sameSite: true,
        });
        setCookie("wst", new Date(), {
          //wellcome-screen-time
          path: "/",
          expires: new Date(
            new Date().setMinutes(new Date().getMinutes() + 30),
          ),
          sameSite: true,
        });
        setUserCookie(userDetails);
        dispatch(updateUserData(userDetails));
        handleClose(userDetails);
      })
      .catch(() => {
        dispatch(disableLoader());
        handleClose();
        dispatch(
          showError(
            `${languageData["User registration failed"] ? languageData["User registration failed"] : "User registration failed"}`,
          ),
        );
      });
  };

  const verifyUser = (userDetails) => {
    dispatch(enableLoader());
    verifyAndRegister(userDetails, otp)
      .then((res: any) => {
        dispatch(disableLoader());
        const userCopy = res.data;
        if (Boolean(userCopy.id)) {
          if ("id" in userDetails) {
            dispatch(
              showSuccess(
                `${languageData["User updated successfully"] ? languageData["User updated successfully"] : "User updated successfully"}`,
              ),
            );
          } else {
            dispatch(
              showSuccess(
                `${languageData["User registered successfully"] ? languageData["User registered successfully"] : "User registered successfully"}`,
              ),
            );
          }
          userDetails = userCopy;
          setAuthToken(res);
          // userDetails.firstName = userDetails.salutation ? `${userDetails.salutation} ${userDetails.firstName}` : userDetails.firstName;
          setCookie("user", userDetails, {
            //user registration fields
            path: "/",
            expires: new Date(
              new Date().setSeconds(new Date().getFullYear() + 1),
            ),
            sameSite: true,
          });
          setCookie("wst", new Date(), {
            //wellcome-screen-time
            path: "/",
            expires: new Date(
              new Date().setMinutes(new Date().getMinutes() + 30),
            ),
            sameSite: true,
          });
          setUserCookie(userDetails);
          dispatch(updateUserData(userDetails));
          handleClose(userDetails);
        } else {
          dispatch(
            showError(
              `${languageData["OTP verification failed"] ? languageData["OTP verification failed"] : "OTP verification failed"}`,
            ),
          );
        }
      })
      .catch(() => {
        dispatch(disableLoader());
        handleClose();
        dispatch(
          showError(
            `${languageData["User registration failed"] ? languageData["User registration failed"] : "User registration failed"}`,
          ),
        );
      });
  };

  const processAPI = (userDetails, processName) => {
    switch (processName) {
      case "verifyAndRegister":
        verifyUser(userDetails);
        break;
      case "sendOTP":
        generateOtp(userDetails);
        break;
      default:
        registerUser(userDetails);
        break;
    }
  };

  const proceed = (processName) => {
    if (validateLoginForm()) {
      if (userData.email && wrongEmail()) {
        setError({ id: "email", text: "" });
        return;
      }
      setError({ id: "", text: "" });
      if (
        userData?.mobileNo &&
        validateNumber(userData?.mobileNo) &&
        userData?.firstName
      ) {
        let userDetails = {
          ...userData,
          uniqueRecordIdentifier: uniqueRecordIdentifier,
        };
        userDetails.countryCode =
          userDetails.countryCode || storeMetaData.countryCode || 91;
        if (userDetails.salutation) {
          userDetails.firstName = `${userDetails.salutation} ${userDetails.firstName}`;
        }
        userDetails.dob = Boolean(userDetails.dob)
          ? getDateObj(new Date(userDetails.dob)).dateObj
          : null;
        if (
          !userDetails.gender &&
          Boolean(storeData?.configData?.genderConfig)
        ) {
          userDetails.gender = storeData.configData.genderConfig.split(",")[0];
        }

        userDetails.anniversaryDate = Boolean(userDetails.anniversaryDate)
          ? getDateObj(new Date(userDetails.anniversaryDate)).dateObj
          : null;
        userDetails.consentSource = "CATALOGUE";
        processAPI(userDetails, processName);
      }
    }
  };

  const getUserDetailsByPhone = (mobileNo) => {
    dispatch(enableLoader());
    return new Promise((res, rej) => {
      getUserByTenantAndMobile(
        storeData?.tenantId,
        storeData?.storeId,
        mobileNo,
        true,
      )
        .then((response: any) => {
          dispatch(disableLoader());
          if (!response) return;
          res(response.data);
          setAuthToken(response);
        })
        .catch(function (error) {
          dispatch(disableLoader());
          dispatch(
            showError(
              `${languageData["Something went wrong.Try after some time."] ? languageData["Something went wrong.Try after some time."] : "Something went wrong.Try after some time."}`,
            ),
          );
          rej(error);
          console.error("error");
        });
    });
  };

  const validateNumber = (num: any) => {
    if (basicConfig.multipleCountryCode) {
      return `${num}`?.length >= 5 && `${num}`?.length <= 15;
    } else {
      if (Boolean(storeMetaData.phoneNoLength)) {
        return Number(storeMetaData.phoneNoLength) == `${num}`?.length;
      } else {
        return `${num}`?.length >= 5 && `${num}`?.length <= 15;
      }
    }
  };

  const checkForExistingCustomer = (mobileNo: string, from?: string) => {
    if (mobileNo) {
      getUserDetailsByPhone(mobileNo)
        .then((data: any) => {
          if (data && data?.mobileNo) {
            const user = data;
            setCookie("user", user, {
              //user registration fields
              path: "/",
              expires: new Date(
                new Date().setFullYear(new Date().getFullYear() + 1),
              ),
              sameSite: true,
            });
            setCookie("wst", new Date(), {
              //wellcome-screen-time
              path: "/",
              expires: new Date(
                new Date().setMinutes(new Date().getMinutes() + 30),
              ),
              sameSite: true,
            });
            setUserCookie(user);
            dispatch(updateUserData(user));
            handleClose(user);
            dispatch(disableLoader());
          } else {
            if (from == "signin") {
              setError({
                id: "not-registered",
                text: `${languageData["Looks like you dont have any account, try using other mobile number or click on Register"] ? languageData["Looks like you dont have any account, try using other mobile number or click on Register"] : "Looks like you dont have any account, try using other mobile number or click on Register"}`,
              });
            } else {
              setShowSignInPage(false);
            }
          }
        })
        .catch((e) => console.error(e));
    } else {
      setShowSignInPage(false);
    }
  };

  const onPhoneChange = (
    mobileNo,
    fetchUser,
    countryCode = storeMetaData.countryCode,
  ) => {
    if (mobileNo.startsWith("0")) {
      mobileNo = mobileNo.toString().replace(/^0+/, "");
      setError({ id: "phone", text: "" });
    } else {
      setError({ id: "", text: "" });
    }
    const num = mobileNo.charAt(mobileNo?.length - 1).replace(".", "");
    if (num && num != " " && !isNaN(num)) {
      if (
        Boolean(storeMetaData.phoneNoLength) &&
        Number(storeMetaData.phoneNoLength) == `${num}`?.length
      )
        return;
      setUserData({ ...userData, mobileNo: mobileNo, countryCode });
      if (!showSignInPage) {
        if (validateNumber(mobileNo) && fetchUser && fromPage != "PROFILE") {
          getUserDetailsByPhone(mobileNo)
            .then((data: any) => {
              if (data && data?.mobileNo) {
                const user = data;
                setCookie("user", user, {
                  //user registration fields
                  path: "/",
                  expires: new Date(
                    new Date().setFullYear(new Date().getFullYear() + 1),
                  ),
                  sameSite: true,
                });
                setCookie("wst", new Date(), {
                  //wellcome-screen-time
                  path: "/",
                  expires: new Date(
                    new Date().setMinutes(new Date().getMinutes() + 30),
                  ),
                  sameSite: true,
                });
                setUserCookie(user);
                dispatch(updateUserData(user));
                handleClose(user);
                dispatch(disableLoader());
              } else
                setError({
                  id: "not-registered",
                  text: `${languageData["Looks like you dont have any account, try using other mobile number or click on sign up"] ? languageData["Looks like you dont have any account, try using other mobile number or click on sign up"] : "Looks like you dont have any account, try using other mobile number or click on sign up"}`,
                });
            })
            .catch((e) => console.error(e));
        }
      }
    } else if (!Boolean(mobileNo?.length))
      setUserData({ ...userData, mobileNo: mobileNo, countryCode });
    else if (userData.countryCode != countryCode)
      setUserData({ ...userData, countryCode });
  };

  const onInputChange = (from, value) => {
    const userDataCopy = { ...userData };
    userDataCopy[from] = value;
    setUserData(userDataCopy);
    setError({ id: "", text: "" });
  };

  const onAddressChange = (e: any) => {
    setError({ id: "", text: "" });
    let userCopy: any = JSON.parse(JSON.stringify(userData));
    if (!Boolean(userCopy.addressList.length)) {
      userCopy.addressList = [
        {
          area: "",
          city: "",
          code: "",
          landmark: "",
          latitude: null,
          line: "",
          longitude: null,
          type: "Home",
        },
      ];
    }
    switch (e.target.id) {
      case "line":
        userCopy.addressList[0].line = e.target.value;
        break;
      case "area":
        userCopy.addressList[0].area = e.target.value;
        break;
      case "city":
        userCopy.addressList[0].city = e.target.value;
        break;
      default:
        break;
    }
    if (userCopy.addressList.length == 0) {
      userCopy = {
        ...userCopy,
        mobileNo: "",
        firstName: "",
        lastName: "",
        email: "",
        marketingConsent: !isGdprEnabled,
        consentSource: "CATALOGUE",
        area: "",
        gender: "",
        dob: "",
        anniversaryDate: "",
        addressList: [],
        tenantId: storeData?.tenantId ? storeData?.tenantId : "",
      };
    }
    setUserData(userCopy);
  };

  const onSelectSource = (source) => {
    setUserData({ ...userData, source });
    setAnchorEl(null);
  };

  const onSelectSalutation = (salutation) => {
    setUserData({ ...userData, salutation });
    setAnchorElSalutation(null);
  };

  const renderSourceList = () => {
    return (
      <div className="sources-list-wrapper">
        <ClickAwayListener
          onClickAway={(e: any) => {
            setAnchorEl(null);
          }}
        >
          <Box>
            {sourcesList.map((sourceDetails: any, i: number) => {
              return (
                <React.Fragment key={i}>
                  <div
                    className={`item-details ${userData.source == sourceDetails.name ? "active" : ""}`}
                    onClick={() => onSelectSource(sourceDetails.name)}
                  >
                    {sourceDetails.name}
                  </div>
                </React.Fragment>
              );
            })}
          </Box>
        </ClickAwayListener>
      </div>
    );
  };

  const renderSalutationsList = () => {
    return (
      <div className="sources-list-wrapper salut-list-wrapper">
        <ClickAwayListener
          onClickAway={(e: any) => {
            setAnchorElSalutation(null);
          }}
        >
          <Box>
            {salutationTypeList.map((salutatonDetails: any, i: number) => {
              return (
                <React.Fragment key={i}>
                  <div
                    className={`item-details salut-list-details ${userData.salutation == salutatonDetails.name ? "active" : ""}`}
                    onClick={() => onSelectSalutation(salutatonDetails.name)}
                  >
                    {salutatonDetails.name}
                  </div>
                </React.Fragment>
              );
            })}
          </Box>
        </ClickAwayListener>
      </div>
    );
  };

  const generateOtp = (userDetails) => {
    setOpenOTPModal(true);
    setTimer(30);
    sendOTP(userDetails)
      .then((res: any) => {
        setOtpMsg(res.message);
        dispatch(
          showSuccess(
            `${languageData["OTP sent successfully"] ? languageData["OTP sent successfully"] : "OTP sent successfully"}`,
          ),
        );
      })
      .catch(() => {
        dispatch(
          showError(
            `${languageData["OTP can not be sent"] ? languageData["OTP can not be sent"] : "OTP can not be sent"}`,
          ),
        );
      });
  };

  const proceedRegistration = (processName) => {
    if (fromPage == "PROFILE" || !otpRegistration) {
      processName = "";
    }
    proceed(processName);
  };

  const handleRetry = () => {
    setTimer(30);
    proceedRegistration("sendOTP");
  };

  const handleVerify = () => {
    proceedRegistration("verifyAndRegister");
  };

  const onChangeOTP = (value) => {
    if (value.toString().length > 4) {
      dispatch(showWarning("OTP should be 4 digits only"));
      return;
    }
    setOtp(value);
  };

  if (!isMounted) {
    return null;
  }

  return (
    <div className="user-reg-modal">
      <div className="cart-page-login-wrap">
        <Backdrop
          className={`backdrop-modal-wrapper ${open && (fromPage == "INITIAL_LOAD" ? showRegistrationScreen || showWellcomeScreen : true) ? "active backdropwrap" : ""}`}
          open={
            open &&
              (fromPage == "INITIAL_LOAD"
                ? showRegistrationScreen || showWellcomeScreen
                : true)
              ? true
              : false
          }
        >
          <div
            className={`backdrop-modal-content half-page-flow profile-main-modal ${!showSignInPage ? "signup" : "signin"} ${fromPage === "PROFILE" ? "profile-edit-flow" : ""}`}
            ref={modalRef}
            style={{ height: `${open ? `${pageheight}` : "0"}` }}
          >
            <div className="modal-wrap profile-modal" ref={modalWrapRef}
              style={
                !showSignInPage && fromPage !== "PROFILE"
                  ? { maxHeight: "none", overflow: "visible" }
                  : undefined
              }
            >
              {showSignInPage ? (
                <>
                  {showSigninInputs ? (
                    <>
                      <div className="heading logo-header">
                        {languageData["Sign In"]
                          ? languageData["Sign In"]
                          : "Sign In"}{" "}
                        {!isUserRegMandatory && (
                          <div
                            className="modal-close"
                            onClick={() => handleClose()}
                          >
                            <IconFrame><CloseLargeIcon /></IconFrame>
                          </div>
                        )}
                      </div>
                      <div className="sub-heading">
                        {heading}.{" "}
                        {languageData[
                          "Enter mobile number to sign in or click on Register"
                        ]
                          ? languageData[
                          "Enter mobile number to sign in or click on Register"
                          ]
                          : "Enter mobile number to sign in or click on Register"}
                      </div>
                      {showSigninInputs && (
                        <div className="page-contain">
                          <div
                            id="cart-phone"
                            className={`input-wrap-with-label phone-number-input glass-card ${error.id == "cart-phone" ? "error" : ""}`}
                          >
                            <div className="input-icon">
                              <FaPhone />
                            </div>

                            {basicConfig?.multipleCountryCode ? (
                              <>
                                <PhoneInput
                                  inputClass={`phonInput input ${error.id == "phone" ? "invalidInput" : ""}`}
                                  value={
                                    `${userData.countryCode || storeMetaData?.countryCode}${userData.mobileNo}` ||
                                    ""
                                  }
                                  onChange={(phone: string, country: any) =>
                                    onPhoneChange(
                                      phone.replace(country.dialCode, ""),
                                      true,
                                      country.dialCode,
                                    )
                                  }
                                  countryCodeEditable={false}
                                  placeholder={
                                    languageData["Mobile Number"]
                                      ? languageData["Mobile Number"]
                                      : "Mobile Number*"
                                  }
                                  country={storeMetaData.code || "in"} // Set the default country here
                                  enableSearch={true}
                                  searchPlaceholder={
                                    languageData["Search country"]
                                      ? languageData["Search country"]
                                      : "Search country"
                                  }
                                  searchNotFound={
                                    languageData["No country found"]
                                      ? languageData["No country found"]
                                      : "No country found"
                                  }
                                  // containerStyle={{ paddingLeft: '36px', width: '80%' }}
                                  inputProps={{
                                    style: { width: "100%", height: "34px" },
                                  }}
                                />
                              </>
                            ) : (
                              <>
                                {/* {storeMetaData?.countryCode && <div className="country-code">+{storeMetaData?.countryCode}</div>} */}
                                <input
                                  className="input"
                                  autoComplete="off"
                                  type="tel"
                                  id="sign-in-phone"
                                  ref={loginNumberInput}
                                  value={userData.mobileNo || ""}
                                  onChange={(e) =>
                                    onPhoneChange(e.target.value, true)
                                  }
                                  maxLength={
                                    Boolean(storeMetaData.phoneNoLength)
                                      ? Number(storeMetaData.phoneNoLength)
                                      : 10
                                  }
                                  placeholder={
                                    languageData["Enter phone number"]
                                      ? languageData["Enter phone number"]
                                      : "Enter phone number*"
                                  }
                                  readOnly={"id" in userData ? true : false}
                                />
                              </>
                            )}
                          </div>
                          <div className="form-wrap">
                            <div
                              onClick={() =>
                                checkForExistingCustomer(
                                  userData.mobileNo,
                                  "register",
                                )
                              }
                              className="btn signup-btn"
                            >
                              {languageData["Register"]
                                ? languageData["Register"]
                                : "Register"}
                            </div>
                            <button
                              className="login-btn"
                              onClick={() =>
                                checkForExistingCustomer(
                                  userData.mobileNo,
                                  "signin",
                                )
                              }
                            >
                              {languageData["Sign In"]
                                ? languageData["Sign In"]
                                : "Sign In"}
                            </button>
                          </div>
                          {error.id == "not-registered" && (
                            <div className="not-registered note">
                              <span className="">{error.text}</span>
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="initial-toast">
                      <div
                        className="sub-heading"
                        onClick={() => setShowSigninInputs(true)}
                      >
                        {languageData["Tap here to sign in"]
                          ? languageData["Tap here to sign in"]
                          : "Tap here to sign in"}
                      </div>
                      {!isUserRegMandatory && (
                        <div
                          className="modal-close"
                          onClick={() => handleClose()}
                        >
                          <IconFrame><CloseLargeIcon /></IconFrame>
                        </div>
                      )}
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className="heading logo-header">
                    {fromPage == "PROFILE"
                      ? languageData["Update Profile"]
                        ? languageData["Update Profile"]
                        : "Update Profile"
                      : languageData["Register"]
                        ? languageData["Register"]
                        : "Register"}{" "}
                    {(!isUserRegMandatory || fromPage != "INITIAL_LOAD") && (
                      <div
                        className="modal-close"
                        onClick={() => handleClose()}
                      >
                        <IconFrame><CloseLargeIcon /></IconFrame>
                      </div>
                    )}
                  </div>
                  <div className="sub-heading">{heading}</div>
                  <div className="page-contain">
                    <div className="form-wrap clearfix" ref={signUpFormRef}>
                      <div
                        id="phone"
                        className={`input-wrap-with-label phone-number-input ${error.id == "phone" ? "error" : ""}`}
                      >
                        <div className="label">
                          <span className="mandatory">*</span>
                        </div>
                        <div className="input-icon">
                          <FaPhone />
                        </div>
                        {basicConfig?.multipleCountryCode ? (
                          <>
                            <PhoneInput
                              inputClass={`phonInput input ${error.id == "phone" ? "invalidInput" : ""}`}
                              value={
                                `${userData.countryCode || storeMetaData?.countryCode}${userData.mobileNo}` ||
                                ""
                              }
                              onChange={(phone: string, country: any) =>
                                onPhoneChange(
                                  phone.replace(country.dialCode, ""),
                                  true,
                                  country.dialCode,
                                )
                              }
                              countryCodeEditable={false}
                              placeholder={
                                languageData["Mobile Number"]
                                  ? languageData["Mobile Number"]
                                  : "Mobile Number*"
                              }
                              country={storeMetaData.code || "in"} // Set the default country here
                              enableSearch={true}
                              searchPlaceholder={
                                languageData["Search country"]
                                  ? languageData["Search country"]
                                  : "Search country"
                              }
                              searchNotFound={
                                languageData["No country found"]
                                  ? languageData["No country found"]
                                  : "No country found"
                              }
                              // containerStyle={{ paddingLeft: '36px', width: '80%' }}
                              inputProps={{
                                style: { width: "100%", height: "30px" },
                              }}
                            />
                          </>
                        ) : (
                          <>
                            {/* {storeMetaData?.countryCode && <div className="country-code">+{storeMetaData?.countryCode}</div>} */}
                            <input
                              className={
                                error.id == "phone"
                                  ? "input invalidInput"
                                  : "input"
                              }
                              autoComplete="off"
                              type="tel"
                              value={userData.mobileNo || ""}
                              onChange={(e) =>
                                onPhoneChange(e.target.value, true)
                              }
                              maxLength={
                                Boolean(storeMetaData.phoneNoLength)
                                  ? Number(storeMetaData.phoneNoLength)
                                  : 10
                              }
                              placeholder={
                                languageData["Mobile Number"]
                                  ? languageData["Mobile Number"]
                                  : "Mobile Number"
                              }
                              readOnly={"id" in userData ? true : false}
                            />
                          </>
                        )}
                      </div>
                      <div
                        id="firstName"
                        className={`input-wrap-with-label ${error.id == "firstName" ? "error" : ""}`}
                      >
                        <div className="label">
                          <span className="mandatory">*</span>
                        </div>
                        <div className="input-icon user-icon-wrap">
                          <BsPersonFill />
                        </div>
                        {Boolean(basicConfig.salutation) &&
                          Boolean(salutationTypeList.length != 0) && (
                            <div
                              id="source"
                              className={`input-wrap-with-label salut-wrapper ${error.id == "source" ? "error" : ""}`}
                            >
                              <div className="source-input-wrapper salut-input-wrapper">
                                <div
                                  className="input input-title"
                                  onClick={(e) =>
                                    setAnchorElSalutation(e.currentTarget)
                                  }
                                >
                                  {userData.salutation
                                    ? `${languageData["Title"] ? languageData["Title"] : "Title"}: ${userData.salutation}`
                                    : `${languageData["Title"] ? languageData["Title"] : "Title"}`}
                                </div>
                                {/* <div className='input input-title' onClick={(e) => setAnchorElSalutation(e.currentTarget)}>
                                                        {userData.salutation ? userData.salutation : 'Title'}
                                                    </div> */}
                                {Boolean(anchorElSalutation) &&
                                  renderSalutationsList()}
                              </div>
                            </div>
                          )}
                        <input
                          className={
                            error.id == "firstName"
                              ? "input invalidInput"
                              : "input"
                          }
                          autoComplete="off"
                          value={userData.firstName || ""}
                          onChange={(e) =>
                            onInputChange("firstName", e.target.value)
                          }
                          placeholder={
                            languageData["Name"] ? languageData["Name"] : "Name"
                          }
                        />
                      </div>
                      {userConfig?.showEmail && (
                        <div
                          id="email"
                          className={`input-wrap-with-label ${error.id == "email" ? "error" : ""}`}
                        >
                          {userConfig?.emailMandatory && (
                            <div className="label">
                              <span className="mandatory">*</span>
                            </div>
                          )}
                          <div className="input-icon">
                            <MdEmail />
                          </div>
                          <input
                            className={
                              error.id == "email"
                                ? "input invalidInput"
                                : "input"
                            }
                            autoComplete="off"
                            type="email"
                            value={userData.email || ""}
                            onChange={(e) =>
                              onInputChange("email", e.target.value)
                            }
                            placeholder={
                              languageData["Email"]
                                ? languageData["Email"]
                                : "Email"
                            }
                          />
                        </div>
                      )}
                      {userConfig?.showDob && (
                        <div
                          className="input-wrap-with-label date-picker-wrap"
                          onClick={openDatePickerFromRow}
                        >
                          <div className="input-icon">
                            <FaCalendarAlt />
                          </div>
                          <DatePicker
                            selected={
                              userData.dob ? new Date(userData.dob) : null
                            }
                            onChange={(date) => onInputChange("dob", date)}
                            customInput={
                              <DatePickerInput from={"Birth date"} />
                            }
                            peekNextMonth
                            showMonthDropdown
                            showYearPicker={false}
                            showYearDropdown={false}
                            dropdownMode="select"
                            dateFormat="MMMM d"
                          // maxDate={new Date()}
                          />
                        </div>
                      )}
                      {userConfig?.showAnniversaryDate && (
                        <div
                          className="input-wrap-with-label date-picker-wrap"
                          onClick={openDatePickerFromRow}
                        >
                          <div className="input-icon">
                            <BiCalendarHeart />
                          </div>
                          <DatePicker
                            selected={
                              userData.anniversaryDate
                                ? new Date(userData.anniversaryDate)
                                : null
                            }
                            onChange={(date) =>
                              onInputChange("anniversaryDate", date)
                            }
                            customInput={
                              <DatePickerInput from={"Anniversary Date"} />
                            }
                            peekNextMonth
                            showMonthDropdown
                            showYearPicker={false}
                            showYearDropdown={false}
                            dropdownMode="select"
                            dateFormat="MMMM d"
                          // maxDate={new Date()}
                          />
                        </div>
                      )}
                      {userConfig?.showAddress && (
                        <>
                          <div
                            className={`input-wrap-with-label ${error.id == "line" ? "error" : ""}`}
                            id="line"
                          >
                            {userConfig?.addressMandatory && (
                              <div className="label">
                                <span className="mandatory">*</span>
                              </div>
                            )}
                            <div className="input-icon">
                              <ImLocation />
                            </div>
                            <input
                              className={
                                error.id == "line"
                                  ? "input invalidInput"
                                  : "input"
                              }
                              id="line"
                              autoComplete="off"
                              value={
                                (userData?.addressList &&
                                  userData?.addressList[0]?.line) ||
                                ""
                              }
                              onChange={(e) => onAddressChange(e)}
                              placeholder={
                                userConfig?.addressMandatory
                                  ? `${languageData["Address"] ? languageData["Address"] : "Address"}*`
                                  : `${languageData["Address"] ? languageData["Address"] : "Address"}`
                              }
                            />
                          </div>
                        </>
                      )}
                      {userConfig?.showGender && (
                        <div
                          id="gender"
                          className={`input-wrap-with-label ${error.id == "gender" ? "error" : ""}`}
                        >
                          <div className="label">
                            <span className="mandatory">*</span>
                          </div>
                          <div className="input-icon">
                            <FaTransgender />
                          </div>
                          <div className="radio-input-wrapper">
                            <div className="radio-input-wrap">
                              <input
                                type="radio"
                                id="male"
                                name="gender"
                                checked={userData.gender == "male"}
                                value={userData.gender || ""}
                                onChange={() => onInputChange("gender", "male")}
                              />
                              <label htmlFor="male" className="cap-text">
                                {languageData["Male"]
                                  ? languageData["Male"]
                                  : "Male"}
                              </label>
                            </div>
                            <div className="radio-input-wrap">
                              <input
                                type="radio"
                                id="female"
                                name="gender"
                                checked={userData.gender == "female"}
                                value={userData.gender || ""}
                                onChange={() =>
                                  onInputChange("gender", "female")
                                }
                              />
                              <label htmlFor="female" className="cap-text">
                                {languageData["Female"]
                                  ? languageData["Female"]
                                  : "Female"}
                              </label>
                            </div>
                          </div>
                        </div>
                      )}

                      {Boolean(
                        sourcesList.length != 0 && userConfig.showSource,
                      ) && (
                          <div
                            id="source"
                            className={`input-wrap-with-label ${error.id == "source" ? "error" : ""}`}
                          >
                            {/* <div className="label"><span className="mandatory">*</span></div> */}
                            <div className="input-icon">
                              <VscSourceControl />
                            </div>
                            <div className="source-input-wrapper">
                              <div
                                className="input"
                                onClick={(e) => setAnchorEl(e.currentTarget)}
                              >
                                {userData.source
                                  ? `${languageData["Source"] ? languageData["Source"] : "Source"}: ${userData.source}`
                                  : `${languageData["Select source"] ? languageData["Select source"] : "Select source"}`}
                              </div>
                              {Boolean(anchorEl) && renderSourceList()}
                            </div>
                          </div>
                        )}

                      {Boolean(basicConfig.gdpr) && (
                        <div className="input-wrap gdpr-consent-wrap">
                          <div className="d-f-ac gap-10">
                            <input
                              type="checkbox"
                              id="marketingConsent"
                              name="marketingConsent"
                              checked={userData.marketingConsent || false}
                              onChange={(e) =>
                                onInputChange(
                                  "marketingConsent",
                                  e.target.checked,
                                )
                              }
                              className="consent-checkbox"
                            />
                            <label
                              htmlFor="marketingConsent"
                              className="consent-label"
                            >
                              I agree to receive promotional messages. I can
                              opt-out at any time.
                            </label>
                          </div>
                        </div>
                      )}

                      {otpRegistration && openOTPModal ? (
                        <div className="otp-modal">
                          <label>{otpMsg}</label>
                          <br />
                          <div className="otp-input-wrap">
                            <input
                              type="number"
                              value={otp}
                              onChange={(event: any) => {
                                onChangeOTP(event.target.value);
                              }}
                              placeholder={
                                languageData["Enter OTP"]
                                  ? languageData["Enter OTP"]
                                  : "Enter OTP"
                              }
                            />
                            <button className="button" onClick={handleVerify}>
                              {languageData["Verify"]
                                ? languageData["Verify"]
                                : "Verify"}
                            </button>
                          </div>
                          <div className="btn-wrap">
                            {Boolean(timer) ? (
                              <span className="timer">
                                {Math.floor(timer / 60)}:
                                {String(timer % 60).padStart(2, "0")}
                              </span>
                            ) : (
                              <span
                                className="retry-button"
                                onClick={handleRetry}
                              >
                                {languageData["Retry"]
                                  ? languageData["Retry"]
                                  : "Retry"}
                              </span>
                            )}
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="btn-wrap">
                            <div
                              className="primary-btn signup-clr"
                              onClick={() => {
                                proceedRegistration("sendOTP");
                              }}
                            >
                              {fromPage == "PROFILE"
                                ? `${languageData["Update"] ? languageData["Update"] : "Update"}`
                                : `${languageData["Register"] ? languageData["Register"] : "Register"}`}
                            </div>
                          </div>

                          {fromPage != "PROFILE" && (
                            <div className="note ">
                              <span className="signup-note">
                                {languageData["Already have an account?"]
                                  ? languageData["Already have an account?"]
                                  : "Already have an account?"}{" "}
                                <span onClick={() => setShowSignInPage(true)}>
                                  {languageData["Sign In"]
                                    ? languageData["Sign In"]
                                    : "Sign In"}
                                </span>
                              </span>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </Backdrop>
      </div>
    </div>
  );
}

export default UserRegistrationModal;

{
  /* <div className='icon-btn  glass-card'>
    <FacebookLogin
        appId="481057589408437"
        autoLoad={false}
        textButton="Facebook"
        fields="name,email,picture"
        callback={responseFacebook}
        cssClass="facebook-login-btn"
        icon={<FacebookIcon />}
    />
</div>  */
}
